import {
  ENABLED,
  DISABLED,
} from '@/constants';
import Transform from './Base';

export default class KeyTransform extends Transform {
  /**
   * Method used to transform a fetched keys.
   *
   * @param key The fetched keys.
   *
   * @returns {Object} The transformed keys.
   */
  static fetch(key) {
    return {
      id: key.id,
      name: key.name,
      created_at: key.created_at,
      active: key.is_active,
      status: key.is_active ? ENABLED : DISABLED,
      token: key.token ? key.token : '',
    };
  }
}
